var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6327 25.4043C15.7178 25.4043 18.6766 24.14 20.8582 21.8896C23.0397 19.6391 24.2653 16.5869 24.2653 13.4043C24.2653 10.2217 23.0397 7.16945 20.8582 4.91902C18.6766 2.66858 15.7178 1.4043 12.6327 1.4043C9.54748 1.4043 6.58867 2.66858 4.40713 4.91902C2.22558 7.16945 1 10.2217 1 13.4043C1 16.5869 2.22558 19.6391 4.40713 21.8896C6.58867 24.14 9.54748 25.4043 12.6327 25.4043Z",
    stroke: "#838383",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72461 16.4721V10.3365C9.72461 9.62693 10.5237 9.17824 11.1745 9.52258L16.9756 12.5921C17.1256 12.6641 17.2526 12.7787 17.3416 12.9226C17.4305 13.0665 17.4778 13.2336 17.4778 13.4043C17.4778 13.575 17.4305 13.7421 17.3416 13.886C17.2526 14.0298 17.1256 14.1445 16.9756 14.2165L11.1762 17.286C10.5237 17.6304 9.72461 17.1817 9.72461 16.4721Z",
    stroke: "#838383",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoGreyIcon);
export default __webpack_public_path__ + "static/media/video-grey-icon.ba9d036af83b1c0abddc6794446bc0fe.svg";
export { ForwardRef as ReactComponent };